import FlexPane from './_flex-pane.js'
import Notification from './_notification.js'

export default {
  name: 'OddsBoostNotification',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {},
    },
    notification: {
      configSet: Notification,
      configValues: {
        container: {
          style: {
            padding: '2px 4px',
            flexGrow: 0,
          },
        },
        text: {
          container: {
            padding: '0 0 0 4px',
          },
        },
        icon: {
          src: 'promotion_boost',
          style: {
            fill: '#666d77',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
